export default __webpack_public_path__ + "static/media/sensotrend_uploader_startup.86d80645.png";